import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import type { DashboardSmaugTypeEnum } from "@/enums"
import { DateHelper } from "@/helpers"
import type {
  DashboardSearchParamsType,
  DashboardSmaugType,
} from "@/types/dashboard"
import { StringHelper } from "@/utils"
export const getDashboardSmaug = async (
  params: DashboardSearchParamsType<DashboardSmaugTypeEnum>
) => {
  const queryString =
    StringHelper.objectToQueryString(params)
  const url = `${ENDPOINTS.DASHBOARD_SMAUG}?${queryString}`
  const { data } = await api.get<DashboardSmaugType>(url)
  return data
}
const useDashboardSmaug = ({
  startDate,
  endDate,
  dashboardType,
  enabled = true,
}: DashboardSearchParamsType<DashboardSmaugTypeEnum> & {
  enabled?: boolean
}) => {
  const { selectedWhiteLabel, authData } = useAuth()
  const isAuthenticated = !!authData?.accessToken
  const { from, to } = DateHelper.getFromAndToDateMonth({
    from: startDate,
    to: endDate,
  })
  const params: DashboardSearchParamsType<DashboardSmaugTypeEnum> =
    {
      startDate: from,
      endDate: to,
      dashboardType,
      whitelabel_ids: selectedWhiteLabel?.uuid,
    }
  return useQuery({
    queryKey: ["dashboard-smaug", params],
    queryFn: async () => {
      const data = await getDashboardSmaug(params)
      return data
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: enabled && isAuthenticated,
  })
}
export default useDashboardSmaug
